import Component from "@glimmer/component"
import styles from "./move-button.module.css"

export default class PlannerCardStacksCardsPartsMoveButtonComponent extends Component {
  readonly styles = styles
}
